import React, { useEffect } from "react";
import '../styles/Form.css'
import logo from '../images/logo.svg';

import { useNavigate } from "react-router-dom";

import axios from "axios";
import { useCookies } from "react-cookie";

export default function Login() {

    const [cookies, setCookie, removeCookie] = useCookies(['user'])
    const [statusMessage, setStatusMessage] = React.useState('')

    let navigate = useNavigate()

    useEffect(() => {
        if (cookies.user?.token) {
            navigate(`/curriculum/`)
        }
    }, [])

    let handleLogin = async (e: any) => {
        e.preventDefault();
        setStatusMessage('Loading...')

        setTimeout(() => {
            axios.post('/Tokens', {
                email: e.target.username.value,
                password: e.target.password.value
            }, {
                withCredentials: true
            }
            ).then((res) => {
                if (res.status === 200) {
                    setStatusMessage('Login Success')
                    removeCookie('user', { path: '/', secure: true, sameSite: 'strict' })
                    setCookie('user', {
                        token: res.data.token,
                        email: res.data.email,
                        staffId: res.data.staffId,
                        firstName: res.data.firstName,
                        lastName: res.data.lastName,
                    }, { path: '/', secure: true, sameSite: 'strict' })
                    navigate(`/curriculum/`)
                }
            }).catch((err) => {
                
                if (err.response?.status === 401) {
                    setStatusMessage('Username or Password is incorrect')
                } else {
                    setStatusMessage('Something went wrong')
                }
            })
        }, 1000)

    }

    return (
        <>
            <main className="Form login">
                <div className="form-container login">
                    <form onSubmit={handleLogin}>
                        <img className="logo" src={logo} alt='Graduate Progression Tracking System Logo'></img>
                        <div className="form-textfield">
                            <input autoComplete="username" placeholder="Username" type='email' required id='username' spellCheck='false' />
                        </div>
                        <div className="form-textfield">
                            <input autoComplete="current-password" placeholder="Password" type='password' required id='password' />
                        </div>
                        <div className="form-actions">
                            <button>Login</button>
                        </div>
                        <div className="form-status-message">
                            <p>{statusMessage}</p>
                        </div>
                    </form>
                </div>
                <div className="Login-footer">
                    <p>Faculty of Science, Chulalongkorn University</p>
                </div>
            </main>
        </>
    );
}